import { Box, Skeleton } from '@mui/material';

export const AccountPreferredSizesSkeleton = () => (
	<Box
		sx={{
			display: 'flex',
			flexDirection: 'row',
			gap: '6px',
		}}
	>
		<Skeleton variant="rectangular" sx={{ height: '82px', width: '100%' }} />
		<Skeleton variant="rectangular" sx={{ height: '82px', width: '100%' }} />
		<Skeleton variant="rectangular" sx={{ height: '82px', width: '100%' }} />
		<Skeleton variant="rectangular" sx={{ height: '82px', width: '100%' }} />
		<Skeleton variant="rectangular" sx={{ height: '82px', width: '100%' }} />
	</Box>
);
